import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface HeroRootProps {
  children: Readonly<ReactNode>;
  wide?: boolean;
  reverse?: boolean;
}

const base_style =
  "z-20 relative max-w-7xl mx-auto mt-12 my-20 px-4 flex flex-col-reverse items-center gap-x-10 ";

export default function Container({ children, wide, reverse }: HeroRootProps) {
  return (
    <div className={cn(base_style, (wide===true ? "justify-between" : "justify-center"), (reverse===true ? "lg:flex-row-reverse" : "lg:flex-row"))}>
      {children}
    </div>
  );
}
